import WrappedPasswordResetMobileForm from './views/PasswordResetMobileView';

export default WrappedPasswordResetMobileForm;